export default function DiscordServerBots() {
  return (
    <>
      {/* ── BOTS ─────────────────────────────────────────────────── */}
      <section className="dsc-section" style={{ paddingTop: "5rem" }}>
        <div className="dsc-eyebrow">Automation</div>
        <h2 className="dsc-h2">
          Meet the <span className="hi">maintainer bots</span>
        </h2>
        <p className="dsc-section-sub">
          Two purpose-built bots handle the heavy lifting 24/7, keeping roles
          clean and members verified without a single manual command.
        </p>

        <div className="dsc-bots">
          <div className="dsc-bot">
            <div className="dsc-bot-top">
              <div className="dsc-bot-icon">⚡</div>
              <span className="dsc-bot-online">Online</span>
            </div>
            <div className="dsc-bot-name">Quantum Role Nuker</div>
            <div className="dsc-bot-role">Role Management Bot</div>
            <p className="dsc-bot-desc">
              When teams restructure or members transition, Quantum Role Nuker
              cleans the slate instantly. It strips and redistributes roles in
              bulk — no manual revocation, no stale permissions, no drift at any
              scale.
            </p>
            <div className="dsc-bot-tags">
              {[
                "Bulk role removal",
                "Restructure support",
                "Audit trail",
                "Zero-drift permissions",
              ].map((t) => (
                <span key={t} className="dsc-bot-tag">
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="dsc-bot">
            <div className="dsc-bot-top">
              <div className="dsc-bot-icon">✅</div>
              <span className="dsc-bot-online">Online</span>
            </div>
            <div className="dsc-bot-name">Quantum Verifier</div>
            <div className="dsc-bot-role">Verification & Onboarding Bot</div>
            <p className="dsc-bot-desc">
              Every new member passes through Quantum Verifier before reaching
              the community. It runs a verification flow, confirms intent, then
              auto-assigns the correct onboarding role — so members land in the
              right channels instantly.
            </p>
            <div className="dsc-bot-tags">
              {[
                "Entry verification",
                "Auto role assignment",
                "Anti-spam gate",
                "Smooth onboarding",
              ].map((t) => (
                <span key={t} className="dsc-bot-tag">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
